import React from 'react';
import { BancameWidgetInstance, getBancameWidget } from '@bancame/widget-js';

interface BancameWidgetProps {
  widgetToken: string;
  publicKey: string;
  onSuccess?: (event: string, metadata: { preApproveId: string, externalTrxId: string }) => void;
  onEvent?: (event: string) => void;
  onReject?: (event:
    'reject_callback'
    |'error_callback', metadata: { preApproveId: string, externalTrxId: string, reason: string }) => void;
  restartWidget?: boolean;
}

export default function BancameWidget({
  widgetToken,
  publicKey,
  onSuccess,
  onEvent,
  onReject,
  restartWidget,
}: BancameWidgetProps) {
  const [widget, setWidget] = React.useState<BancameWidgetInstance | undefined>(undefined);

  const initWidget = async () => {
    const newWidget = await getBancameWidget();
    const widgetInstance = newWidget?.create({
      publicKey,
      widgetToken,
      onSuccess: ({ event, metadata }:
        { event: string, metadata: { preApproveId: string, externalTrxId: string } }) => {
        onSuccess?.(event, metadata);
      },
      onEvent: ({ event }: { event: string }) => {
        onEvent?.(event);
      },
      onReject: (
        { event, metadata }:
        { event: 'reject_callback' | 'error_callback',
          metadata: {
            preApproveId: string,
            externalTrxId: string,
            reason: string,
          },
        },
      ) => {
        onReject?.(event, metadata);
      },
      buttonMode: 'hidden',
      widgetProps: {
        hideCloseButton: true,
        autoCloseOnSuccess: true,
        autoCloseOnRejection: false,
      },
    });
    widgetInstance?.open();
    setWidget(widgetInstance);
  };

  const handleRestartWidget = async () => {
    widget?.destroy();
    const newWidget = await getBancameWidget();
    const widgetInstance = newWidget?.create({
      publicKey,
      widgetToken,
    });
    widgetInstance?.open();
    setWidget(widgetInstance);
  };

  React.useEffect(() => {
    initWidget();
  }, [widgetToken]);

  React.useEffect(() => {
    if (restartWidget) {
      handleRestartWidget();
    }
  }, [restartWidget]);

  return <div id="bancame-widget" />;
}

BancameWidget.defaultProps = {
  onSuccess: () => {},
  onEvent: () => {},
  onReject: () => {},
  restartWidget: false,
};
